import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

import {
  Question,
  QuestionOption,
  parseQuestionDetail,
} from 'src/app/feature/onboarding-v2/models/question.model';

import { declaracionOptionKeywordSegments } from './declaracion-option-keyword-segments';

@Component({
  selector: 'app-question-item',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './question-item.component.html',
  styleUrls: ['./question-item.component.scss'],
})
export class QuestionItemComponent {
  readonly question = input.required<Question>();
  readonly selectedOptionId = input<string | null>(null);
  readonly expanded = input<boolean>(false);
  readonly index = input<number | null>(null);
  /** Solo declaración jurada: resaltar SI / NO / SÍ en negrita. */
  readonly emphasizeOptionKeywords = input(false);

  readonly selectionChange = output<string>();
  readonly toggle = output<void>();

  readonly detailParts = computed(() =>
    parseQuestionDetail(this.question().detail),
  );

  readonly selectedOption = computed<QuestionOption | null>(() => {
    const id = this.selectedOptionId();
    if (!id) {
      return null;
    }
    return (
      this.question().options.find((o) => o.optionId === id) ?? null
    );
  });

  readonly headerText = computed(() => {
    const idx = this.index();
    const desc = this.question().description;
    return idx !== null && idx !== undefined ? `${idx}. ${desc}` : desc;
  });

  onHeaderClick(): void {
    this.toggle.emit();
  }

  onOptionSelect(optionId: string): void {
    this.selectionChange.emit(optionId);
  }

  /** Segmentos de opción; el resaltado de palabras clave solo si `emphasizeOptionKeywords`. */
  optionDisplaySegments(description: string): {
    text: string;
    emphasize: boolean;
  }[] {
    if (!this.emphasizeOptionKeywords()) {
      return description ? [{ text: description, emphasize: false }] : [];
    }
    return declaracionOptionKeywordSegments(description);
  }
}
